"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListMultipleExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/select-list/examples/multiple.ts';
var CountryList = _1.SelectList.ofType();
var SelectListMultipleExample = /** @class */ (function () {
    function SelectListMultipleExample() {
        var _this = this;
        this.selectedItems = new Map();
        this.renderItem = function (item) { return (0, mithril_1.default)(_1.ListItem, {
            label: item.name,
            selected: _this.selectedItems.has(item.name)
        }); };
        this.handleSelect = function (item) {
            if (_this.selectedItems.has(item.name)) {
                _this.selectedItems.delete(item.name);
            }
            else
                _this.selectedItems.set(item.name, item);
        };
    }
    SelectListMultipleExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(CountryList, {
                closeOnSelect: false,
                items: examples_1.countries,
                itemRender: this.renderItem,
                itemPredicate: this.itemPredicate,
                onSelect: this.handleSelect,
                popoverAttrs: { hasArrow: false },
                trigger: (0, mithril_1.default)(_1.Button, {
                    align: 'left',
                    compact: true,
                    iconRight: _1.Icons.CHEVRON_DOWN,
                    sublabel: 'Country:',
                    label: "".concat(this.selectedItems.size, " selected"),
                    style: 'min-width: 300px'
                })
            })
        ]);
    };
    SelectListMultipleExample.prototype.itemPredicate = function (query, item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
    };
    return SelectListMultipleExample;
}());
exports.SelectListMultipleExample = SelectListMultipleExample;
